/* 
 * Chart for telemetry
 */
import { Component, input, OnInit } from '@angular/core';
import * as echarts from 'echarts/core';
import moment from 'moment';
import {
  LineChart, BarChart, PieChart
  // or BarChart, PieChart, etc.
} from 'echarts/charts';


import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  // etc.
} from 'echarts/components';

import {
  CanvasRenderer
} from 'echarts/renderers';

import type {
  ComposeOption
} from 'echarts/core';

import type {
  LineSeriesOption, BarSeriesOption, PieSeriesOption
} from 'echarts/charts';

import type {
  TitleComponentOption,
  TooltipComponentOption,
  GridComponentOption,
  LegendComponentOption,
} from 'echarts/components';

@Component({
  selector: 'app-echart',
  standalone: false,
  templateUrl: './echart.component.html',
  styleUrl: './echart.component.css'
})
export class EchartComponent implements OnInit {

  telemetry = input.required<any[]>();
  height = input.required<string>();
  chartType = input<'line' | 'bar' | 'pie'>('line');
  telemetryLabel = input<string>('Telemetry');
  weather = input<any>(null);

  chartInstance?: echarts.ECharts;
  chartOptions: EChartsOption = {
    title: {
      text: 'Sample EChart'
    },
    tooltip: {},
    xAxis: {
      data: ['A', 'B', 'C', 'D', 'E', 'F']
    },
    yAxis: {},
    series: [
      {
        name: 'Count',
        type: 'bar',
        data: [5, 20, 36, 10, 10, 20]
      }
    ]
  };

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (!this.telemetry()?.length) return;

    setTimeout(() => {
      this.timeseries();
    }, 100);

  }

  timeseries() {
    const chartDom = document.getElementById('main');

    // Prepare telemetry data
    const telemetryData = this.telemetry()
      .sort((a, b) => (a.c > b.c ? 1 : (b.c > a.c ? -1 : 0)))
      .map(item => [item.c, item.v]);

    // Prepare weather data only if available
    const weather = this.weather();
    const hasWeather = weather && Array.isArray(weather) && weather.length > 0;
    const weatherData = hasWeather
      ? weather
        .sort((a, b) => (a.c > b.c ? 1 : (b.c > a.c ? -1 : 0)))
        .map(item => [item.c, item.v])
      : [];

    // Build series array
    const series: any[] = [
      {
        name: this.telemetryLabel(),
        type: this.chartType(),
        data: telemetryData,
        smooth: true,
        showSymbol: false,
        yAxisIndex: 0
      }
    ];

    if (hasWeather) {
      series.push({
        name: 'Weather',
        type: 'line',
        data: weatherData,
        smooth: true,
        showSymbol: false,
        yAxisIndex: 1
      });
    }

    // Conditionally define yAxis
    const yAxis: any = [
      {
        type: 'value',
        name: this.telemetryLabel(),
        position: 'left'
      }
    ];

    if (hasWeather) {
      yAxis.push({
        type: 'value',
        name: 'Weather',
        position: 'right'
      });
    }

    const option: EChartsOption = {
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          const date = moment(params[0].value[0]).format('DD-MM-YYYY HH:mm');
          let result = `${date}<br/>`;
          params.forEach((p: any) => {
            result += `${p.seriesName}: ${p.value[1]}<br/>`;
          });
          return result;
        }
      },
      legend: hasWeather ? { data: [this.telemetryLabel(), 'Weather'] } : { data: [this.telemetryLabel()] },
      xAxis: {
        type: 'time',
        axisLabel: {
          formatter: (value: number) => moment(value).format('DD')
        }
      },
      yAxis,
      series,
      dataZoom: [
        {
          type: 'slider',
          xAxisIndex: 0,
          start: 0,
          end: 100
        },
        {
          type: 'inside',
          xAxisIndex: 0
        }
      ]
    };

    this.chartInstance = echarts.init(chartDom);
    this.chartInstance.setOption(option);
  }

  ngOnDestroy(): void {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
}

type EChartsOption = ComposeOption<
  | LineSeriesOption
  | BarSeriesOption
  | PieSeriesOption
  | TitleComponentOption
  | TooltipComponentOption
  | GridComponentOption
  | LegendComponentOption
>;
